import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <article className="site-page">
      <div className="site-page__inner">
        <h1 className="site-page__title">Page not found</h1>
        <p className="site-page__lead">
          Nothing lives at this URL. Check the address or return home.
        </p>
        <p className="site-page__muted">
          <Link to="/">← Back to home</Link>
        </p>
      </div>
    </article>
  );
}
